import { useEffect } from "react"
import { Link } from "react-router-dom"
import ContactForm from "./ContactForm"
import { IMPRESSUM_CONTACT, landingCopy } from "./landingCopy"
import { useLandingLocale } from "./landingLocale"
import { LandingFooter, LandingHeader, useLandingDocument } from "./LandingShell"

const ImpressumPage = () => {
  const { locale, setLandingLocale, ready } = useLandingLocale()
  const copy = landingCopy(locale)

  useLandingDocument(locale, copy.impressumMetaTitle, copy.metaDescription)

  useEffect(() => {
    if (window.location.hash !== "#contact") return
    window.requestAnimationFrame(() => {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" })
    })
  }, [ ready ])

  if (!ready) {
    return <div className="landing-page" aria-busy="true" aria-label="Loading" />
  }

  return (
    <div className="landing-page">
      <LandingHeader locale={locale} onLocaleChange={setLandingLocale} contactHref="/impressum#contact" />

      <main className="landing-section landing-legal-page">
        <p className="landing-legal-back">
          <Link to="/">← {copy.impressumBack}</Link>
        </p>
        <h1>{copy.impressumTitle}</h1>

        <div className="landing-legal-block">
          <p><strong>Viridian GmbH</strong></p>
          <p>Burgstr. 1</p>
          <p>06114 Halle (Saale)</p>
          <p>Germany</p>
        </div>

        <div className="landing-legal-block">
          <p>
            <strong>{copy.impressumDirectors}:</strong><br />
            Ilia Zonov, Nitzan Oren
          </p>
          <p>
            <strong>{copy.impressumCourt}:</strong> Amtsgericht Halle<br />
            <strong>{copy.impressumRegister}:</strong> HRB 31037<br />
            <strong>{copy.impressumVat}:</strong> DE350603872
          </p>
          <p style={{ marginTop: "0.75rem" }}>
            <strong>{copy.impressumGeneral}:</strong><br />
            <a href={`mailto:${IMPRESSUM_CONTACT.email}`}>{IMPRESSUM_CONTACT.email}</a>
          </p>
        </div>

        <div className="landing-legal-block landing-impressum-form" id="contact">
          <h2>{copy.contactFormTitle}</h2>
          <p>{copy.impressumContactNote}</p>
          <ContactForm copy={copy} locale={locale} />
        </div>
      </main>

      <LandingFooter locale={locale} />
    </div>
  )
}

export default ImpressumPage
